export const calculateModalPosition = (e: any, modalWidth: number) => {
  const mouseX = e.screenX;
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (screenWidth - mouseX < modalWidth * 2) {
    return 'left';
  }
  return 'right';
};
